var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newoferta"},[_c('OfertaForm',{attrs:{"oferta":_vm.oferta,"type":_vm.tipus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }